import { useNavigate, useSearchParams } from 'react-router-dom';
import JSAManager from '@/components/JSAManager';
import ErrorBoundary from '@/components/ErrorBoundary';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

const SupervisorJSAs = ({ user, setUser }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const divisionIdFromUrl = searchParams.get('divisionId');

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Button
          variant="ghost"
          onClick={() => window.history.back()}
          className="mb-4 hover:bg-gray-100"
        >
          ← {t('common.back')}
        </Button>

        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">{t('supervisorPages.jsasTitle')}</h1>
          <p className="text-gray-600 mt-1">{t('supervisorPages.jsasSubtitle')}</p>
        </div>

        <ErrorBoundary>
          <JSAManager user={user} divisionIdOverride={divisionIdFromUrl} />
        </ErrorBoundary>
      </main>
    </div>
  );
};

export default SupervisorJSAs;
